<template>
    <div v-if="onViewListingDesktop">
        <section class="mb-8 flex justify-end gap-2">
            <a
                :class="[
                    'button group',
                    favourite ? 'button--salmon' : 'button--salmon-hover',
                ]"
                @click="toggleFavourite"
            >
                <template v-if="!favourite">
                    <v-icon icon="heart" class="group-hover:hidden"></v-icon>
                    <v-icon
                        icon="heart-solid"
                        class="hidden group-hover:flex"
                    ></v-icon>
                    <label>Shrani oglas</label>
                </template>
                <template v-else>
                    <v-icon
                        icon="heart-solid"
                        class="group-hover:flex"
                    ></v-icon>
                    Priljubljen oglas
                </template>
            </a>
        </section>
    </div>
    <div class="flex" v-if="onViewListingGallery">
        <a
            class="button button--dark-3 max-md:px-2 max-md:py-2"
            @click="toggleFavourite"
        >
            <template v-if="!favourite">
                <v-icon icon="heart" class="max-md:!h-6 max-md:!w-6"></v-icon>
                <span class="max-md:hidden">Shrani oglas</span>
            </template>
            <template v-else>
                <v-icon
                    icon="heart-solid"
                    class="max-md:!h-6 max-md:!w-6"
                ></v-icon>
                <span class="max-md:hidden">Priljubljen oglas</span>
            </template>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        estateOnofficeId: {
            type: Number,
            required: true,
        },
        toggleFavoriteRoute: {
            type: String,
            required: true,
        },
        isFavorite: {
            type: Boolean,
            required: true,
        },
        onViewListingDesktop: {
            type: Boolean,
            required: true,
            default: false,
        },
        onViewListingMobile: {
            type: Boolean,
            required: true,
            default: false,
        },
        onViewListingGallery: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    mounted() {
        this.favourite = this.isFavorite;
    },
    data() {
        return {
            favourite: false,
        };
    },
    methods: {
        toggleFavourite() {
            let data = {
                on_office_id: this.estateOnofficeId,
            };

            axios
                .post(this.toggleFavoriteRoute, data, {
                    headers: {
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.favourite = response.data.status;
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        },
    },
};
</script>
